'use client'
import { useContextElement } from '@/context/Context'
// import { products16 } from '@/data/products/fashion'
import Link from 'next/link'
import { useContext, useEffect, useState } from 'react'
import { Navigation } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import Image from 'next/image'

import styles from './AddToWishlistButton.module.css'

export default function AddToWishlistButton({
  Product,
  type,
  WishlistButtonPosition,
}) {
  const { toggleWishlist, isAddedtoWishlist } = useContextElement()
  const isAdd = isAddedtoWishlist(Product.ProductID, Product.SkuID)

  if (WishlistButtonPosition === 'Image') {
    switch (type) {
      case '2':
        return (
          <button
            className={`pc__btn-wl position-absolute bg-transparent border-0 js-add-wishlist ${
              isAdd ? 'active' : ''
            }`}
            style={{ top: '-10px', right: '-12px', zIndex: 3 }}
            onClick={() => toggleWishlist(Product, Product.SkuID)}
            title="Add To Wishlist"
          >
            {isAdd ? (
              <svg
                width="26"
                height="26"
                viewBox="0 0 16 16"
                style={{
                  color: '#e63946',
                  fill: '#e63946',
                }}
              >
                <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
              </svg>
            ) : (
              <svg
                width="26"
                height="26"
                viewBox="0 0 20 20"
                style={{ color: '#333', fill: '#333' }}
              >
                <use href="#icon_heart" />
              </svg>
            )}
          </button>
        )
      case '3':
        return (
          <button
            className={`pc__btn-wl position-absolute bg-transparent border-0 js-add-wishlist ${
              isAdd ? 'active' : ''
            }`}
            style={{ top: '-10px', right: '-12px', zIndex: 3 }}
            onClick={() => toggleWishlist(Product, Product.SkuID)}
            title="Add To Wishlist"
          >
            {isAdd ? (
              <svg
                width="25"
                height="25"
                viewBox="0 0 16 16"
                style={{
                  color: '#e63946',
                  fill: '#e63946',
                  display: 'block',
                }}
              >
                <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
              </svg>
            ) : (
              <svg
                width="25"
                height="25"
                viewBox="0 0 20 20"
                style={{ color: '#333', fill: '#333' }}
              >
                <use href="#icon_heart" />
              </svg>
            )}
          </button>
        )
      case '4':
        return (
          <button
            className={`pc__btn-wl position-absolute bg-transparent border-0 js-add-wishlist ${
              isAdd ? 'active' : ''
            } pe-2`}
            style={{ top: '-10px', right: '-12px', zIndex: 3 }}
            onClick={() => toggleWishlist(Product, Product.SkuID)}
            title="Add To Wishlist"
          >
            {isAdd ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 16 16"
                style={{
                  color: '#e63946',
                  fill: '#e63946',
                  display: 'block',
                }}
              >
                <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                style={{ color: '#333', fill: '#333' }}
              >
                <use href="#icon_heart" />
              </svg>
            )}
          </button>
        )
      case '6':
        return (
          <button
            className={`pc__btn-wl position-absolute bg-transparent border-0 js-add-wishlist ${
              isAdd ? 'active' : ''
            }`}
            style={{
              top: '-10px',
              right: '-12px',
              zIndex: 3,
              width: '32px',
              height: '32px',
            }}
            onClick={() => toggleWishlist(Product, Product.SkuID)}
            title="Add To Wishlist"
          >
            {isAdd ? (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                style={{
                  color: '#e63946',
                  fill: '#e63946',
                }}
              >
                <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
              </svg>
            ) : (
              <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                style={{ color: '#333', fill: '#333' }}
              >
                <use href="#icon_heart" />
              </svg>
            )}
          </button>
        )
    }
  } else if (WishlistButtonPosition === 'Price') {
    return (
      <button
        type="button"
        className={`pc__btn-wl bg-transparent border-0 js-add-wishlist ${
          isAdd ? 'active' : ''
        } ${styles.priceWishlistBtn}`}
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          toggleWishlist(Product, Product.SkuID)
        }}
        title="Add To Wishlist"
      >
        {isAdd ? (
          <svg
            width="20"
            height="20"
            viewBox="0 0 16 16"
            className={styles.priceHeartIcon}
            style={{
              color: '#e63946',
              fill: '#e63946',
            }}
          >
            <path d="M8 1.314C12.438-3.248 23.534 4.735 8 15-7.534 4.736 3.562-3.248 8 1.314z" />
          </svg>
        ) : (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            className={styles.priceHeartIcon}
            style={{
              color: '#071d33',
              fill: '#071d33',
            }}
          >
            <use href="#icon_heart" />
          </svg>
        )}
      </button>
    )
  }
}
